/**
 *  Default state for the sections/classes store
 *
 *@module Sections
 * @category Store
 * @subcategory Sections
 * @name State
 * @returns { object } Default state for sections/classes
 */
export function getDefaultState() {
  return {
    mySectionsMap: {},
    myArchivedSectionGroups: {},

    sectionsTeachersMap: {},
    sectionsStudentsMap: {},

    sectionsProfilePictures: {},

    sectionsTeamsMap: {},

    sectionRootDriveMap: {},
    sectionRootSubDrivesMap: {},

    allInstitutionSections: []
  };
}

const state = getDefaultState();

export default state;
